import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/Tooltip';

// eslint-disable-next-line react/function-component-definition
const ReactionTransferTo = ({ onClick }) => (
  <span className="reactions-item-connector--transfer-to u-els-font-size-base">
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} theme="simple" tooltip="Transfer to retrosynthesis">
      <ButtonWithIcon
        data-e2e="reactions-transfer-to"
        sprite="Flask"
        type="link"
        iconOnly
        className="e2e-reactions-transfer-to"
        onClick={onClick}
        aria-label="Transfer to retrosynthesis">
        Transfer to retrosynthesis
      </ButtonWithIcon>
    </HoverTooltip>
  </span>
);

ReactionTransferTo.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReactionTransferTo;
